import { AttrIndexService } from './attr-index.service';
import * as math from 'mathjs';
import { Fill, Stroke, Style } from 'ol/style';
import { LineString, MultiLineString } from 'ol/geom';
import { transform } from 'ol/proj';
import * as i0 from "@angular/core";
import * as i1 from "./attr-index.service";
var MapSharedService = /** @class */ (function () {
    function MapSharedService(attrIndexService) {
        var _this = this;
        this.attrIndexService = attrIndexService;
        this.minZoomLevel = 4; // 4 is about the entire US
        this.arrowStyleResolution = 5;
        this.initBasemapOpacity = 0.4;
        this.basemapLayerName = 'basemapCroups';
        this.bgColorMap = {
            1: '#E8E8E8',
            2: '#C3ECB2',
            3: '#AADAFF',
            4: '#FFF2AF'
        };
        this.get4ColorPolygonStyle = function (feat) {
            var props = feat.getProperties();
            var bgColor = _this.get4ColorBgColor(props) || '#F5F5DC'; // default: beige
            return new Style({
                fill: new Fill({
                    color: bgColor
                })
            });
        };
    }
    // Check for 4-color
    MapSharedService.prototype.get4ColorBgColor = function (props) {
        return this.bgColorMap[props[this.attrIndexService.bdryColorCol]];
    };
    // Get style of an arrow at the end of line
    // Params: lf -> line feature
    MapSharedService.prototype.getLineArrowStyle = function (lf, reso, isMultiLine, options, forceDraw) {
        if (!forceDraw && reso > this.arrowStyleResolution) {
            return;
        }
        // Line coordinates
        var coords;
        if (isMultiLine) { // MultiLineString
            var coordsArr = lf.getGeometry().getCoordinates();
            coords = coordsArr[coordsArr.length - 1];
        }
        else { // LineString
            coords = lf.getGeometry().getCoordinates();
        }
        if (!coords) {
            return;
        }
        // lf.getGeometry().getCoordinates();
        // End point coords
        var ep = coords[coords.length - 1];
        // Last second point coords
        var sp = coords[coords.length - 2];
        if (ep && sp) {
            // 	// Rotation of arrow
            // 	const r = Math.atan2(ep[1] - sp[1], ep[0] - sp[0]);
            // 	// Arrow style
            // 	options = options || {}
            // return new Style({
            // 	geometry: new Point(ep),
            // 	image: new Icon({
            // 		src: 'assets/css/img/' + (options.img || 'olmap_arrow.png'),
            // 		anchor: [0.55, 0.5],
            // 		rotateWithView: false,
            // 		rotation: -r,
            // 		color: options.color || 'pink',
            // 		scale: options.scale || 0.3,
            // 		crossOrigin: 'anonymous'
            // 	})
            // });
            // Reference: https://stackoverflow.com/questions/41606206/draw-arrow-without-using-any-image-in-openlayers3
            var dx = ep[0] - sp[0];
            var dy = ep[1] - sp[1];
            var rotation = Math.atan2(dy, dx);
            var diffX = 15;
            var diffY = 5;
            if (reso < 1) {
                diffX = reso * diffX;
                diffY = reso * diffY;
            }
            else {
                diffX = reso * 1.5 + diffX;
                diffY = reso * 1.2 + diffY;
            }
            var lineStr = new MultiLineString([[ep, [ep[0] - diffX, ep[1] + diffY]], [ep, [ep[0] - diffX, ep[1] - diffY]]]);
            lineStr.rotate(rotation, ep);
            var stroke = new Stroke({
                color: options.color,
                width: 3
            });
            return new Style({
                geometry: lineStr,
                stroke: stroke
            });
        }
    };
    MapSharedService.prototype.updateLayerOpacity = function (olLayer, opacity) {
        olLayer.setOpacity(opacity);
        olLayer.changed();
    };
    MapSharedService.prototype.isCoordsEqual = function (coordA, coordB, geomPrecision) {
        if (geomPrecision || geomPrecision === 0) {
            return coordA[0].toFixed(geomPrecision) === coordB[0].toFixed(geomPrecision) && coordA[1].toFixed(geomPrecision) === coordB[1].toFixed(geomPrecision);
        }
        return coordA[0] === coordB[0] && coordA[1] === coordB[1];
    };
    MapSharedService.prototype.getLineFeatureDirection = function (olGeom) {
        if (!olGeom) {
            return;
        }
        var direction;
        var geomType = olGeom.getType();
        var startPoint;
        var endPoint;
        switch (geomType) {
            case 'LineString':
                var coords = olGeom.getCoordinates();
                startPoint = coords[0];
                endPoint = coords[coords.length - 1];
                break;
            case 'MultiLineString':
                var coordsArray = olGeom.getCoordinates();
                if (coordsArray.length) {
                    startPoint = coordsArray[0][0];
                    var endLine = coordsArray[coordsArray.length - 1];
                    endPoint = endLine[endLine.length - 1];
                }
                break;
            default:
                break;
        }
        if (!startPoint || !endPoint) {
            return;
        }
        else {
            var theta = Math.atan2(endPoint[1] - startPoint[1], endPoint[0] - startPoint[0]) * 180 / Math.PI;
            if (theta > -135 && theta <= -45) {
                direction = 'S';
            }
            else if (theta > -45 && theta <= 45) {
                direction = 'E';
            }
            else if (theta > 45 && theta <= 135) {
                direction = 'N';
            }
            else { // if (theta > 135 && theta <= 180) {
                direction = 'W';
            }
            console.log(direction);
            return direction;
        }
    };
    MapSharedService.prototype.getRangeOverlap = function (rangeA, rangeB) {
        var largerX = Math.max(rangeA[0], rangeB[0]);
        var smallerY = Math.min(rangeA[1], rangeB[1]);
        if (largerX < smallerY) {
            return [largerX, smallerY];
        }
    };
    // Find the prev & next points on a polygon where the give coord falls between
    // Return the index of prev/next points
    MapSharedService.prototype.findCoordPositionOnPolygon = function (coord, polygonCoords) {
        var _this = this;
        // TODO !!!!!
        // const lineCoords: number[][] = polygonCoords[0];
        var lineCoords;
        var indexes;
        var lineCoordsIdx;
        polygonCoords.find(function (line, idx) {
            indexes = _this.findCoordPositionOnLine(coord, line);
            if (indexes) {
                lineCoords = line;
                lineCoordsIdx = idx;
                return true;
            }
        });
        return {
            indexes: indexes,
            lineCoordsIdx: lineCoordsIdx
            // lineCoords: lineCoords
        };
    };
    MapSharedService.prototype.findCoordPositionOnLine = function (coord, lineCoords) {
        // const lineCoords: number[][] = polygonCoords[0];
        var Xmax, Xmin, Ymax, Ymin;
        for (var x = 0; x < lineCoords.length - 1; x++) { // find the two points that XYcoord falls in between
            Xmax = Math.max(lineCoords[x][0], lineCoords[x + 1][0]);
            Xmin = Math.min(lineCoords[x][0], lineCoords[x + 1][0]);
            Ymax = Math.max(lineCoords[x][1], lineCoords[x + 1][1]);
            Ymin = Math.min(lineCoords[x][1], lineCoords[x + 1][1]);
            var determinant = void 0;
            if (Xmin <= coord[0] && coord[0] <= Xmax && Ymin <= coord[1] && coord[1] <= Ymax) {
                // if coord falls in between, check if the three points are collinear using the determinant of Matrix
                var matrixCollinear = [
                    [lineCoords[x][0], lineCoords[x][1], 1],
                    [lineCoords[x + 1][0], lineCoords[x + 1][1], 1],
                    [coord[0], coord[1], 1]
                ];
                // The condition of collinearity is:
                // the determinant of the matrix equals 0, which is the ideal case. Usually, the det would be around 0.
                // smaller det is better
                determinant = math.det(matrixCollinear);
                if ((Math.abs(math.det(matrixCollinear)) < 0.01)) { // TODO
                    // const prev = lineCoords[x];
                    // const next = lineCoords[x + 1];
                    return [x, x + 1];
                }
            }
        }
    };
    // Get a closest point on geom and the with the given coord
    MapSharedService.prototype.calcCoordOnGeom = function (geom, coord) {
        var _this = this;
        var polygons;
        var geomType = geom.getType();
        if (geomType === 'MultiPolygon') {
            polygons = geom.getCoordinates();
        }
        else if (geomType === 'Polygon') {
            polygons = [geom.getCoordinates()];
        }
        else {
            console.log('Geom type not supported for finding neighbor points.', geomType);
            return;
        }
        var coordOnGeom = geom.getClosestPoint(coord);
        var idxResult;
        var targetPolygon = polygons.find(function (polygon) {
            idxResult = _this.findCoordPositionOnPolygon(coordOnGeom, polygon).indexes;
            return !!idxResult;
        });
        if (targetPolygon && idxResult) {
            return {
                polygonCoords: targetPolygon[0],
                coordOnGeom: coordOnGeom,
                neighborIdxes: idxResult
            };
        }
    };
    // Get partial coordinates on a polygon/multi-polygon between 2 clicks
    MapSharedService.prototype.getCoordinatesOnGeomBetweenPoints = function (pointA, pointB, geom) {
        var resultA = this.calcCoordOnGeom(geom, pointA);
        var resultB = this.calcCoordOnGeom(geom, pointB);
        if (!resultA || !resultB) {
            return;
        }
        if (JSON.stringify(resultA.polygonCoords) !== JSON.stringify(resultB.polygonCoords)) {
            console.log('Two points not on same polygon!!');
            return;
        }
        var polygonCoords = resultA.polygonCoords;
        var direction;
        var coords;
        var coordsAgainst;
        // If A, B fall in the same two points
        if (resultA.neighborIdxes[0] === resultB.neighborIdxes[0]) {
            coords = [resultA.coordOnGeom, resultB.coordOnGeom];
        }
        else {
            // If A, B fall in different part of polygon
            var startIdx = void 0, endIdx = void 0;
            // direction = 'natural'
            if (resultA.neighborIdxes[0] <= resultB.neighborIdxes[0]) {
                startIdx = resultA.neighborIdxes[1];
                endIdx = resultB.neighborIdxes[0];
                coords = polygonCoords.slice(startIdx, endIdx + 1);
                if (!this.isCoordsEqual(resultA.coordOnGeom, coords[0])) {
                    coords.unshift(resultA.coordOnGeom);
                }
                if (!this.isCoordsEqual(resultB.coordOnGeom, coords[coords.length - 1])) {
                    coords.push(resultB.coordOnGeom);
                }
            }
            else if (resultA.neighborIdxes[0] > resultB.neighborIdxes[0]) {
                var partA = polygonCoords.slice(resultA.neighborIdxes[1], polygonCoords.length - 1);
                if (!this.isCoordsEqual(resultA.coordOnGeom, partA[0])) {
                    partA.unshift(resultA.coordOnGeom);
                }
                var partB = polygonCoords.slice(0, resultB.neighborIdxes[0] + 1);
                if (!this.isCoordsEqual(resultB.coordOnGeom, partB[partB.length - 1])) {
                    partB.push(resultB.coordOnGeom);
                }
                coords = partA.concat(partB);
            }
            // direction = 'against'
            if (resultA.neighborIdxes[0] <= resultB.neighborIdxes[0]) {
                var partA = polygonCoords.slice(0, resultA.neighborIdxes[0] + 1);
                if (!this.isCoordsEqual(resultA.coordOnGeom, partA[partA.length - 1])) {
                    partA.push(resultA.coordOnGeom);
                }
                var partB = polygonCoords.slice(resultB.neighborIdxes[1], polygonCoords.length - 1);
                if (!this.isCoordsEqual(resultB.coordOnGeom, partB[0])) {
                    partB.unshift(resultB.coordOnGeom);
                }
                coordsAgainst = partB.concat(partA);
            }
            else if (resultA.neighborIdxes[0] > resultB.neighborIdxes[0]) {
                startIdx = resultB.neighborIdxes[1];
                endIdx = resultA.neighborIdxes[0];
                coordsAgainst = polygonCoords.slice(startIdx, endIdx + 1);
                if (!this.isCoordsEqual(resultB.coordOnGeom, coordsAgainst[0])) {
                    coordsAgainst.unshift(resultB.coordOnGeom);
                }
                if (!this.isCoordsEqual(resultA.coordOnGeom, coordsAgainst[coordsAgainst.length - 1])) {
                    coordsAgainst.push(resultA.coordOnGeom);
                }
            }
        }
        // Calculate the geom's angle at pointA
        var prev = resultA.polygonCoords[resultA.neighborIdxes[0]];
        var next = resultA.polygonCoords[resultA.neighborIdxes[1]];
        var thetaA = Math.atan2(next[1] - prev[1], next[0] - prev[0]) * 180 / Math.PI;
        return {
            coords: coords,
            thetaA: thetaA,
            //
            coordsAgainst: coordsAgainst
        };
    };
    MapSharedService.prototype.isPointOnPolygonEdge = function (coord, geom) {
        var _this = this;
        var geomType = geom.getType();
        if (geomType === 'Polygon') {
            return !!this.findCoordPositionOnPolygon(coord, geom.getCoordinates()).indexes;
        }
        else if (geomType === 'MultiPolygon') {
            return !!geom.getCoordinates().find(function (p) { return _this.findCoordPositionOnPolygon(coord, p).indexes; });
        }
    };
    MapSharedService.prototype.getSplitLineByPoint = function (lineFeat, pointOnRoad) {
        var roadCoords = lineFeat.getGeometry().getCoordinates();
        var pos = this.findCoordPositionOnLine(pointOnRoad, roadCoords);
        var splitCoords = roadCoords.slice(0, pos[0] + 1);
        var lastCoord = splitCoords[splitCoords.length - 1];
        if (!this.isCoordsEqual(pointOnRoad, lastCoord)) {
            splitCoords.push(pointOnRoad);
        }
        var splitLine = new LineString(splitCoords);
        return {
            first: splitLine
        };
    };
    MapSharedService.prototype.getSegByGeomPercent = function (lineGeom, percent) {
        var result = {
            coords: null
        };
        if (percent >= 0 && percent <= 1) {
            var lineLength_1 = lineGeom.getLength();
            var coords_1 = lineGeom.getCoordinates();
            var newGeom_1 = new LineString([]);
            var startIdx_1 = 0, endIdx_1 = coords_1.length - 1;
            var idx_1;
            var currentPercent_1;
            var safe_1 = 0;
            var check_1 = function () {
                safe_1++;
                if (endIdx_1 <= startIdx_1 || safe_1 > 5000) {
                    return;
                }
                idx_1 = startIdx_1 + Math.floor((endIdx_1 - startIdx_1) / 2);
                var coordsPrev = coords_1.slice(0, idx_1 + 1);
                newGeom_1.setCoordinates(coordsPrev);
                var startLength = newGeom_1.getLength();
                currentPercent_1 = startLength / lineLength_1;
                if (percent > currentPercent_1) {
                    var coordsAfter = coords_1.slice(0, idx_1 + 2);
                    newGeom_1.setCoordinates(coordsAfter);
                    var afterLength = newGeom_1.getLength();
                    var afterPercent = afterLength / lineLength_1;
                    if (percent < afterPercent) {
                        var deltaLength = lineLength_1 * (percent - currentPercent_1);
                        var deltaPercent = deltaLength / (afterLength - startLength);
                        var x = coords_1[idx_1][0] + (coords_1[idx_1 + 1][0] - coords_1[idx_1][0]) * deltaPercent;
                        var y = coords_1[idx_1][1] + (coords_1[idx_1 + 1][1] - coords_1[idx_1][1]) * deltaPercent;
                        coordsPrev.push([x, y]);
                        result.coords = coordsPrev;
                        return;
                    }
                    else if (percent > afterPercent) {
                        startIdx_1 = idx_1 + 1;
                        check_1();
                    }
                    else if (percent === afterPercent) {
                        result.coords = coordsAfter;
                        return;
                    }
                }
                else if (percent < currentPercent_1) {
                    endIdx_1 = idx_1;
                    check_1();
                }
                else if (percent === currentPercent_1) {
                    result.coords = coordsPrev;
                    return;
                }
            };
            check_1();
        }
        return result;
    };
    MapSharedService.prototype.transformPointToLatlong = function (coord, rec) {
        var latlong = transform(coord, 'EPSG:3857', 'EPSG:4326');
        var precision = 6;
        var lat = Number(latlong[1].toFixed(precision));
        var long = Number(latlong[0].toFixed(precision));
        if (rec) {
            rec[this.attrIndexService.addrLatitudeCol] = lat;
            rec[this.attrIndexService.addrLongitudeCol] = long;
        }
        return [long, lat];
    };
    MapSharedService.prototype.sortPointsAtSameLocation = function (pointsList, geomPrecision) {
        var track = {};
        pointsList.forEach(function (coord, idx) {
            if (!coord) {
                return;
            }
            var trackIdx;
            if (geomPrecision || geomPrecision === 0) {
                trackIdx = coord[0].toFixed(geomPrecision) + '_' + coord[1].toFixed(geomPrecision);
            }
            else {
                trackIdx = coord[0] + '_' + coord[1];
            }
            if (!track[trackIdx]) {
                track[trackIdx] = [];
            }
            track[trackIdx].push(idx);
        });
        return track;
    };
    MapSharedService.prototype.changeCursor = function (map, cursorStyle) {
        map.getViewport().style.cursor = cursorStyle;
    };
    MapSharedService.prototype.mergeExtent = function (extents) {
    };
    MapSharedService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MapSharedService_Factory() { return new MapSharedService(i0.ɵɵinject(i1.AttrIndexService)); }, token: MapSharedService, providedIn: "root" });
    return MapSharedService;
}());
export { MapSharedService };
